import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface StatCardProps {
  label: string;
  value: string;
  subValue?: string;
  trend?: 'up' | 'down' | 'flat';
  trendValue?: string;
  icon?: string;
  variant?: 'default' | 'alert' | 'positive' | 'warning';
  mono?: boolean;
}

export default function StatCard({
  label,
  value,
  subValue,
  trend,
  trendValue,
  icon,
  variant = 'default',
  mono = true,
}: StatCardProps) {
  const variantClasses = {
    default: 'card stat-card-hover',
    alert: 'card stat-card-hover border-negative/30 bg-negative-subtle',
    positive: 'card stat-card-hover border-positive/30 bg-positive-subtle',
    warning: 'card stat-card-hover border-warning/30 bg-warning-subtle',
  };

  const trendConfig = {
    up: { icon: 'ArrowTrendingUpIcon', color: 'text-positive' },
    down: { icon: 'ArrowTrendingDownIcon', color: 'text-negative' },
    flat: { icon: 'MinusIcon', color: 'text-muted-foreground' },
  };

  return (
    <div className={`${variantClasses[variant]} p-4`}>
      <div className="flex items-start justify-between mb-3">
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">{label}</p>
        {icon && (
          <Icon
            name={icon as Parameters<typeof Icon>[0]['name']}
            size={16}
            className={
              variant === 'alert' ? 'text-negative' :
              variant === 'positive' ? 'text-positive' :
              variant === 'warning'? 'text-warning' : 'text-muted-foreground'
            }
          />
        )}
      </div>
      <p className={`text-2xl font-bold leading-none mb-1 ${mono ? 'font-mono-data' : ''} ${
        variant === 'alert' ? 'text-negative' :
        variant === 'positive' ? 'text-positive' :
        variant === 'warning'? 'text-warning' : 'text-foreground'
      }`}>
        {value}
      </p>
      {subValue && <p className="text-xs text-muted-foreground mt-1">{subValue}</p>}
      {trend && trendValue && (
        <div className={`flex items-center gap-1 mt-2 ${trendConfig[trend].color}`}>
          <Icon name={trendConfig[trend].icon as Parameters<typeof Icon>[0]['name']} size={12} />
          <span className="text-xs font-mono-data">{trendValue}</span>
        </div>
      )}
    </div>
  );
}